import React, { forwardRef } from 'react'
import { Box, Checkbox, HStack, Skeleton, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react'
import { Column } from './MasterTable'

interface LoadingTableProps {
  columns: Column[]
  rows?: number
  minHeight?: string | number
}

const LoadingTable = forwardRef<HTMLDivElement, LoadingTableProps>(
  ({ columns, rows = 10, minHeight = '58vh' }, ref) => {
    return (
      <Box
        ref={ref}
        width="100%"
        minHeight={minHeight}
        overflowX="auto"
        overflowY="visible"
      >
        <Table width="100%" sx={{ tableLayout: 'fixed' }}>
          <Thead>
            <Tr>
              {columns.map((column) => (
                <Th
                  key={column.accessor}
                  width={column.width}
                  bg="transparent"
                  color="solid.400"
                  textTransform="none"
                  letterSpacing="normal"
                  fontSize="12px"
                  fontWeight="500"
                  borderBottomWidth="1px"
                  borderColor="solid.50"
                  whiteSpace="normal"
                  wordBreak="break-word"
                  overflowWrap="anywhere"
                  py="10px"
                >
                  {column.type === 'select' ? (
                    <Checkbox isDisabled />
                  ) : column.type === 'actions' ? (
                    <Skeleton height="12px" width="44px" borderRadius="6px" />
                  ) : (
                    <Skeleton height="12px" width="70%" borderRadius="6px" />
                  )}
                </Th>
              ))}
            </Tr>
          </Thead>
          <Tbody>
            {Array.from({ length: rows }).map((_, rowIndex) => (
              <Tr key={rowIndex}>
                {columns.map((column) => (
                  <Td key={column.accessor} width={column.width} py="14px">
                    {column.type === 'select' ? (
                      <Checkbox isDisabled />
                    ) : column.type === 'actions' ? (
                      <HStack spacing="2" width="100%">
                        <Skeleton borderRadius="8px" height="28px" width="28px" />
                      </HStack>
                    ) : column.accessor === 'name' ? (
                      <HStack spacing="10px" width="100%">
                        <Skeleton borderRadius="full" height="36px" width="36px" flexShrink={0} />
                        <Skeleton height="14px" width="60%" borderRadius="6px" />
                      </HStack>
                    ) : (
                      <Skeleton height="14px" width={column.type === 'custom' ? '70%' : '85%'} borderRadius="6px" />
                    )}
                  </Td>
                ))}
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
    )
  }
)

export default LoadingTable
